import React from 'react';
import { string } from 'prop-types';

const IconChevronSvg = ({ transform }) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      transition: 'all 0.3s',
      transform,
    }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2318 17.3598C13.5854 16.9355 14.2159 16.8782 14.6402 17.2318L20 21.6983L25.3598 17.2318C25.7841 16.8782 26.4147 16.9355 26.7682 17.3598C27.1218 17.7841 27.0645 18.4147 26.6402 18.7682L20.6402 23.7682C20.2694 24.0773 19.7307 24.0773 19.3598 23.7682L13.3598 18.7682C12.9356 18.4147 12.8782 17.7841 13.2318 17.3598Z"
      fill="#06090D"
    />
  </svg>
);

IconChevronSvg.propTypes = {
  transform: string.isRequired,
};

const IconChevron = {
  Up: () => <IconChevronSvg transform="rotate(180deg)" />,
  Down: () => <IconChevronSvg transform="rotate(0deg)" />,
};

export default IconChevron;
